import request from '@/utils/request'

export const listRoles = () => {
    return request({
        url: '/systems/roles/switch',
        method: 'get'
    })
}

export const updateRole = (roleId) => {
    return request({
        url: `/systems/roles/switch/${roleId}`,
        method: 'put'
    })
}